<template>
    <div id="filterContainer" class="w-60 bg-white shadow-md rounded-lg pl-4 pr-8 py-4 flex flex-col gap-2 z-100">
        <div v-for="[key, value] in Object.entries(props.availableFilters)" :key="key">
            <div class="capitalize text-midea-text">
                {{ key }}
            </div>
            <FormSelect
                :ignoreGrid="true"
                id="key"
                v-model="selectedVal[key]"
                :options="value"
                defaultOption="No filter"
            />
        </div>
    </div>
</template>

<script setup>
    import { defineProps, ref, watch, defineEmits } from 'vue'
    import FormSelect from './FormSelect.vue'

    const props = defineProps(['availableFilters', 'modelValue'])
    const emit = defineEmits(['update:modelValue', 'change'])

    const selectedVal = ref(props.modelValue)

    watch(selectedVal, () => {
        emit('update:modelValue', selectedVal)
        emit('change')
    }, { deep: true })
</script>